module.exports = __webpack_public_path__ + "static/fonts/NanumSquareEB.9b98722.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareEB.eot
// module id = rRaH
// module chunks = 1